export default __webpack_public_path__ + "static/nicole-sullivan-2c2cfd3b566f4e9c4c69cf90f48a0edf.jpg";